import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { learnerCourseListRes, learnerCourseListTodo } from '../../LMS_Redux/LMS_Slices/Course/LearnerCourseList'
import { PropagateLoader } from 'react-spinners'
import DataTables from '../LMS_DATA_TABLE/DataTable'

export default function UserCourse(props) {

    const { user_id } = props
    const dispatch = useDispatch()
    const data = useSelector(state => state.learnerCourseList && state.learnerCourseList.data && state.learnerCourseList.data.data)
    const [loading, setLoading] = useState(false)

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'IMAGE',
            field: 'lms_master_course.thumbnail_image',
            cellRenderer: (params) => <img src={process.env.REACT_APP_IMAGE_URL + `${params.value}`} alt="img" className='img-fluid' width="50" height="50" />,
            suppressMenu: true,
            filter: false,
            sortable: false,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'TITLE',
            field: 'lms_master_course.course_title',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'ID',
            field: 'lms_master_course.course_code',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'REVISION',
            field: 'lms_master_course.revise',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'STATUS',
            field: 'learner_course_status',
            cellRenderer: params =>
                params.value == 'pass' ? <span className='badge text-bg-success text-capitalize'>{params.value}</span> :
                    params.value == 'failed' || params.value == 'expired' ? <span className='badge text-bg-danger text-capitalize'>{params.value}</span> :
                        params.value == 'pending' ? <span className='badge text-bg-warning text-capitalize'>{params.value}</span> :
                            params.value == 'started' ? <span className='badge text-bg-info text-capitalize'>{params.value}</span>
                                : '',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true
        },
        {
            headerName: 'PROGRESS',
            field: 'progress_bar',
            cellRenderer: (params) =>
                <div className="progress" role="progressbar" aria-label="Success example" aria-valuenow={params.value} aria-valuemin="0" aria-valuemax="100" style={{ marginTop: '13px' }}>
                    <div className="progress-bar bg-success" style={{ "width": params.value + '%' }}>{params.value + '%'}</div>
                </div>
            ,
            // wrapText: true,
            // autoHeight: true
        },
    ]);

    const course_res = () => {
        if (learnerCourseListRes && learnerCourseListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(learnerCourseListTodo({ "user_id": user_id, "training_type": "Course Wise" })).then(() => course_res())
    }, [])

    return (
        <>
            <div className="media">
                <div className="profile-shadow w-100">
                    {loading ?
                        <div className='wrapper-admin'>
                            <div className='text-center mb-3'>
                                <PropagateLoader
                                    color="#2262C6"
                                    size={20}
                                />
                            </div>
                        </div>
                        :
                        <>
                            {data && data.length ?
                                <DataTables
                                    rowData={data}
                                    columnDefs={columnDefs}
                                />
                                :
                                <div className='wrapper-admin'>
                                    <div className='text-center'>
                                        <h5>Learning Module List Not Found</h5>
                                    </div>
                                </div>
                            }
                        </>
                    }
                </div>
            </div>
        </>
    )
}
